export default __webpack_public_path__ + "static/media/kiril_s.42ffafd8.jpg";